import { assocPath, pick } from 'ramda'
import { useParams } from 'react-router-dom'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { fetchVailHistory, useOrg } from '@/hooks'
import usePromise from '@/hooks/usePromise'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'
import { camelize, parseComponentTypes } from '@/utils'
import { ComponentType } from '@/utils/api'

import { TaskTrackerData, TaskTrackerSettings } from '../types'

export const parseTaskTrackerData = async (
  orgSlug?: string,
  param?: TaskTrackerData
) => {
  if (!orgSlug || !param) return {}
  const data = parseComponentTypes(param, ComponentType.taskTracker)
  const component = (
    await fetchVailHistory(data?.settings.customRecipeOffRamp?.version)
  )?.data.getVailHistory
  if (!data) return {}
  try {
    const filteredSettings = pick(
      ['conversation', 'displayEGsBy', 'displayMenu', 'orderBy'],
      data.settings
    )

    return {
      data: {
        ...assocPath(
          ['customRecipeOffRamp'],
          !!data.settings.customRecipeOffRamp?.version
            ? `workshop/${orgSlug}/solutionEntryPoint/taskTracker/${camelize(
                JSON.parse(component?.data || '{}').name
              )}`
            : null,
          filteredSettings
        ),
        egOrder: ['this'],
      },
      organization: orgSlug,
      schemaName: 'TaskTrackerMenuConfig',
      schemaVersion: '1.0.0',
      version: '1.0.0',
    }
  } catch (e) {
    return {}
  }
}

export const useParseTaskTrackerData = (
  orgSlug?: string,
  param?: TaskTrackerData
) => {
  return usePromise(parseTaskTrackerData(orgSlug, param))
}

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)

  const current = useGetCustomComponent<TaskTrackerSettings>(componentID)
  const config = usePromise(parseTaskTrackerData(org.data?.slug, current.data))
  const valid = useValidateEndpoint(config, componentID)

  if (!config) return null
  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Task Tracker"
      valid={valid}
    />
  )
}
